(function($) {
  "use strict";

  jQuery(document).ready(function(){


    /* preloader */
    $(window).on('load', function() {
      $('#preloader_active').fadeOut('slow');
    }); 


    /* Match Height */  
    $(function() {
      $('.match_height > div').matchHeight();
    });



    /*------------------------------------
    01. Sticky Menu
-------------------------------------- */  
    var win = $(window);
    var stick = $(".header-sticky");
    var stick2 = $(".header-area");
    win.on('scroll',function() {    
      var scroll = win.scrollTop();
      if (scroll < 245) {
        stick.removeClass("sticky");
        stick2.removeClass("header_z");
      }else{
        stick.addClass("sticky");
        stick2.addClass("header_z");
      }
    }); 

    /*------------------------------------
    02. Last 2 li child add class
-------------------------------------- */  
    $('ul.menu>li').slice(-2).addClass('last-elements');

    /*------------------------------------
    03. jQuery MeanMenu
-------------------------------------- */
    $('.main-menu nav').meanmenu({
      meanScreenWidth: "991",
      meanMenuContainer: '.mobile-menu'
    }); 

    /*-------------------------------------
    04. MagnificPopup image popup
--------------------------------------- */
    $('.img-popup').magnificPopup({
      type: 'image',
      gallery:{
        enabled:true
      }
    });

    /*---------------------------------
    05. Countdown
----------------------------------- */	
    $('[data-countdown]').each(function() {
      var $this = $(this), finalDate = $(this).data('countdown');
      $this.countdown(finalDate, function(event) {
        $this.html(event.strftime('<div class="cdown days"><span class="counting">%-D</span>Days</div><div class="cdown hours"><span class="counting">%-H</span>Hours</div><div class="cdown minutes"><span class="counting">%M</span>Minutes</div><div class="cdown seconds"><span class="counting">%S</span>Seconds</div>'));
      });
    });	



    /*----------------------------------------
    Best Product Slide
---------------------------------------- */
    $('.ht-best-p-wrapper').owlCarousel({
      loop:true,
      items:2,
      nav:true,
      navText : ['<i class="fa fa-angle-double-left"></i>','<i class="fa fa-angle-double-right"></i>'],
      responsive:{
        0:{
          items:1
        },
        480:{
          items:1
        },
        768:{
          items:2
        }, 
        992:{
          items:1
        }, 
        1200:{
          items:2
        }
      }
    });
    /*----------------------------------------
    Countdown Product Slide
---------------------------------------- */
    $('.ht-countdown-slider').owlCarousel({
      loop:true,
      nav:true,
      navText : ['<i class="fa fa-angle-double-left"></i>','<i class="fa fa-angle-double-right"></i>'],
      responsive:{
        0:{
          items:1
        },
        600:{
          items:1
        },
        1000:{
          items:1
        }
      }
    });


    /*----------------------------------------
    Blog Carousel Two
---------------------------------------- */
    $('.ht-blog-carousel-two').owlCarousel({
      loop:true,
      nav:true,
      navText : ['<i class="fa fa-angle-double-left"></i>','<i class="fa fa-angle-double-right"></i>'],
      responsive:{
        0:{
          items:1
        },
        480:{
          items:1
        },
        768:{
          items:3
        }, 
        992:{
          items:4
        }, 
        1200:{
          items:4
        }
      }
    });
    /*----------------------------------------
    Best Product Two
---------------------------------------- */
    $('.ht-best-p-wrapper-two').owlCarousel({
      loop:true,
      items:1,
      nav:true,
      navText : ['<i class="fa fa-angle-double-left"></i>','<i class="fa fa-angle-double-right"></i>'],
      responsive:{
        0:{
          items:1
        },
        480:{
          items:1
        },
        768:{
          items:1
        }, 
        992:{
          items:1
        }, 
        1200:{
          items:1
        }
      }
    });


    /*------------------------------------
	07. Slick Carousel
--------------------------------------*/
    /*------------------------------------
	Home Four Slick Slider
--------------------------------------*/
    $('.image-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      draggable: false,
      fade: true,
      asNavFor: '.slider-nav'
    });
    $('.nav-image-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.image-slider',
      dots: false,
      vertical: true,
      arrows: false,
      centerMode: true,
      focusOnSelect: true,
      centerPadding: '10px',
      responsive: [
        {
          breakpoint: 760,
          settings: {
            dots: false,
            slidesToShow: 3,  
            centerPadding: '0px',
            vertical: false,
          }
        },
        {
          breakpoint: 420,
          settings: {
            dots: false,
            slidesToShow: 3,
            vertical: false,
          }
        }
      ]
    });

    /*----------------------------------------
	Product Details Slick Slider
------------------------------------------*/
$('.product-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,             // enable arrows
  prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left"></i></button>',
  nextArrow: '<button class="slick-next"><i class="fa fa-angle-right"></i></button>',
  fade: true,
  asNavFor: '.slider-nav-slick',
  adaptiveHeight: true
});

$('.slider-nav-slick').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.product-slider',
  arrows: false,
  focusOnSelect: true,
  centerPadding: '0',
  responsive: [
    {
      breakpoint: 1360,
      settings: { slidesToShow: 4 }
    },
    {
      breakpoint: 800,
      settings: { slidesToShow: 3 }
    },
    {
      breakpoint: 500,
      settings: { slidesToShow: 4 }
    },
    {
      breakpoint: 380,
      settings: { slidesToShow: 3 }
    }
  ]
});

    if ($('.slider-nav-slick').length) {
      $('.slider-nav-slick').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.product-slider',
      arrows: true,
      focusOnSelect: true,
      centerPadding: '0',
      responsive: [
        {
          breakpoint: 1360,
          settings: {
            dots: false,
            slidesToShow: 4,  
            centerPadding: '0px',
          }
        },
        {
          breakpoint: 800,
          settings: {
            dots: false,
            slidesToShow: 3,  
            centerPadding: '0px',
          }
        },
        {
          breakpoint: 500,
          settings: {
            dots: false,
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 380,
          settings: {
            dots: false,
            slidesToShow: 3,
          }
        }
      ]
    });
  }

    /*------------------------------------------
    mega menu
------------------------------------------- */    
    $('.mega-menu').parent('ul').addClass('megamenu');





    /*------------------------------------------
    08. ScrollUp
------------------------------------------- */	
    $.scrollUp({
      scrollText: '<i class="fa fa-chevron-up"></i>',
      easingType: 'linear',
      scrollSpeed: 900,
      animation: 'fade'
    });  

    /*------------------------------------------
    09. Price Slider Activate
-------------------------------------------- */  
    $( "#slider-range" ).slider({
      range: true,
      min: 110,
      max: 300,
      values: [ 120, 240 ],
      slide: function( event, ui ) {
        $( "#amount" ).val( "$" + ui.values[ 0 ] + " - $" + ui.values[ 1 ] );
      }
    });
    $( "#amount" ).val( "$" + $( "#slider-range" ).slider( "values", 0 ) +
                       " - $" + $( "#slider-range" ).slider( "values", 1 ) );  

    /*------------------------------------------
    10. Wow js
-------------------------------------------- */    
    new WOW().init();

    /*-----------------------------------------
    11. Newletter Modal On Load
----------------------------------------- */ 
    win.on('load', function() {
      $('#newslettermodal').modal('show');
    });	




    /* Ajax Cart */
    $(".cart-item").on('click', function(){
      $(this).addClass("loading add-item");
      setTimeout(function () {
        $(".cart-item").removeClass("loading");
      },1000);
      setTimeout(function () {
        $(".cart-item").removeClass("add-item");
      },2000);

    });


    /* Ajax Wishlist */
    $(".action--wishlist").on('click', function(){
      $(this).addClass("loading-wishlist add-wishlist");
      setTimeout(function () {
        $(".action--wishlist").removeClass("loading-wishlist");
      },1000);
      setTimeout(function () {
        $(".add-wishlist").removeClass("add-wishlist");
      },2000);

    });



    /* Remove Attr  */   
    $('.disabled-add-to-cart').removeAttr('href');











  });

})(jQuery);


document.addEventListener("DOMContentLoaded", function () {
  const minusBtn = document.querySelector(".qty-btn.minus");
  const plusBtn = document.querySelector(".qty-btn.plus");
  const qtyInput = document.querySelector(".cart-plus-minus-box");

  if (minusBtn && plusBtn && qtyInput) {
    minusBtn.addEventListener("click", function () {
      let value = parseInt(qtyInput.value);
      if (value > 1) qtyInput.value = value - 1;
    });

    plusBtn.addEventListener("click", function () {
      let value = parseInt(qtyInput.value);
      qtyInput.value = value + 1;
    });
  }
});


document.addEventListener("DOMContentLoaded", () => {
  const cartDrawer = document.getElementById("CartDrawer");

  // Function to open the drawer
  function openDrawer() {
    cartDrawer.classList.add("open");
    document.body.style.overflow = "hidden";
  }

  // Function to refresh the drawer contents
async function updateDrawer() {
  const response = await fetch("/cart?view=drawer");
  const html = await response.text();
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const newCartContent = tempDiv.querySelector("#CartDrawerContent");
  if (newCartContent && cartDrawer) {
    cartDrawer.querySelector("#CartDrawerContent").innerHTML = newCartContent.innerHTML;
  }
}


  // Handle Add-to-Cart form submissions
  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault(); // stop redirect immediately

      const formData = new FormData(form);

      try {
        // Add item without redirect
        await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });

        // Update drawer & show it
        await updateDrawer();
        openDrawer();

      } catch (err) {
        console.error("Error adding to cart:", err);
      }
    });
  });

  // Handle closing drawer
  document.addEventListener("click", (e) => {
    if (e.target.matches("#CloseCartDrawer")) {
      cartDrawer.classList.remove("open");
      document.body.style.overflow = "auto";
    }
  });
});
document.addEventListener("DOMContentLoaded", function() {
  var variantSelect = document.querySelector('.variant-select');
  var productSelect = document.querySelector('#productSelect');
  var priceEl = document.querySelector('.prod_price');

  if (variantSelect && productSelect) {
    variantSelect.addEventListener('change', function() {
      var selectedOption = this.options[this.selectedIndex];
      productSelect.value = selectedOption.value;

      // Update price if data-price attribute exists
      if (selectedOption.dataset.price && priceEl) {
        priceEl.innerHTML = selectedOption.dataset.price;
      }
    });
  }
});